var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcPause = function SvgIcPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9 23H15c-.8 0-1.4-.6-1.4-1.4V2.4c-.1-.8.6-1.4 1.4-1.4h5.9c.8 0 1.4.6 1.4 1.4v19.1c0 .9-.6 1.5-1.4 1.5zM9 23H3.1c-.8 0-1.4-.6-1.4-1.4V2.4c0-.8.6-1.4 1.4-1.4H9c.8 0 1.4.6 1.4 1.4v19.1c.1.9-.6 1.5-1.4 1.5z"
  })));
};
export default SvgIcPause;